import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions
} from "@tanstack/react-query";

import {
  PoiBrandSearchPayload,
  PoiParameterResponse,
  PoiSearchPayload,
  PoiSearchResponse,
  PostPoiParametersPayload,
  PostPoiParametersResponse
} from "@/types/poiParameter";

import {
  getBrandsSearch,
  getDatasetsSearch,
  getPoiParameters,
  postPoiParameters
} from "./poiParameterApi";

export const useGetParametersQuery = (
  country_id?: string,
  options?: Omit<
    UseQueryOptions<PoiParameterResponse, Error, PoiParameterResponse>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["poi-parameters", country_id],
    queryFn: () => getPoiParameters(country_id),
    ...options
  });
};

export const useGetBrandsByCategoryMutation = (
  options?: Omit<
    UseMutationOptions<PoiSearchResponse, Error, PoiBrandSearchPayload>,
    "mutationFn"
  >
) => {
  return useMutation({
    mutationFn: (payload: PoiBrandSearchPayload) => getBrandsSearch(payload),
    ...options
  });
};

export const useGetSearchDatasetsQuery = (
  payload: PoiSearchPayload,
  options?: Omit<
    UseQueryOptions<PoiSearchResponse, Error, PoiSearchResponse>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["search-datasets", payload],
    queryFn: () => getDatasetsSearch(payload),
    ...options
  });
};

export const useGetDatasetsByPoiParameters = (
  payload: PostPoiParametersPayload,
  options?: Omit<
    UseQueryOptions<
      PostPoiParametersResponse,
      Error,
      PostPoiParametersResponse
    >,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["post-poi-parameters", payload],
    queryFn: () => postPoiParameters(payload),
    ...options
  });
};
